import ShopArticlesListByCategoryPagingResultModelBase from '../_generated/modelBases/shop-articles-list-by-category-paging-result-model-base';

export default class ShopArticlesListByCategoryPagingResultModel extends ShopArticlesListByCategoryPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
